module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('a', {
    staticClass: "close-btn",
    attrs: {
      "href": "javascript:;"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "用户名"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    attrs: {
      "type": "password",
      "placeholder": "密码"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn"
  }, [_vm._v("登录")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e114275"}!./~/vue-loader/lib/selector.js?type=template&index=0!./pc/index/components/r-login.vue
// module id = 840
// module chunks = 9